import zh_cn_text from './zh-cn';
import en_us_text from './en-us';
import { getLocaleLanguage, LanguageType } from '../lib';
import { isSupportSystem } from '../config';

export const getLanguage = getLocaleLanguage();

const loadLanguageText = (language: LanguageType): Record<string, string> => {
  if (isSupportSystem()) {
    return zh_cn_text;
  }
  if (language === LanguageType.zh_CN) {
    return zh_cn_text;
  }
  // default load en us language
  return en_us_text;
};

function getStr(str: string, params: any) {
  const arrKey = str.match(/[^{{]+(?=}})/g);
  let newStr = str;
  if (arrKey) {
    arrKey.forEach((item) => {
      if (params[item] !== undefined) {
        newStr = newStr.replace(`{{${item}}}`, params[item]);
      }
    });
  }
  return newStr;
}

/*
  value: 待翻译值
  ignoreCase: 是否忽略大小写，默认true 
*/
interface IOptions {
  ignoreCase?: boolean;
  params?: any;
}

// 增加languageType可选参数，文档等本地没有存储语言的可使用
function getFormatMessage(
  value: string,
  options: IOptions = {},
  languageType?: LanguageType
) {
  const { ignoreCase = true, params } = options;
  const translateText = loadLanguageText(
    languageType || getLanguage || LanguageType.en_US
  );

  let key = value;
  if (ignoreCase) {
    key = key.toLowerCase();
  }
  let res = translateText[key] || translateText[value];
  if (res === undefined) {
    res = value;
  }
  if (params) {
    res = getStr(res, params);
  }

  return res;
}

export default getFormatMessage;
